import { FC, useMemo } from 'react'
import { useHistory } from "react-router-dom"
import cn from 'classnames'

import { useScreen } from '../../utils/hooks'
import { useTopNavigation } from './TopNavigationContext'
import styles from './style.module.scss'

export type { NavigationLink, NavigationButton } from './types'

const TopNavigation: FC = () => {
    const history = useHistory()
    const { links, buttons } = useTopNavigation()
    const { isMobile } = useScreen()

    const linkItems = useMemo(() => {
        return links
            ? links.map((l, i) => (
                <div key={i} className={cn({
                    [styles.active]: l.active,
                    [styles.mobile]: isMobile
                })}

                    onClick={() => history.push(l.link)}>
                    {l.name}
                </div>
            ))
            : null
    }, [history, isMobile, links])

    const buttonItems = useMemo(() => {
        return buttons
            ? buttons.map((l, i) => (
                <div key={i} className={cn({
                    [styles.active]: l.active,
                    [styles.mobile]: isMobile
                })}
                    onClick={e => l.onClick(l.value)}>
                    {l.caption}
                </div>
            )) : null
    }, [buttons, isMobile])

    return <div className={styles.navigation}>
        <div className={styles.inner}>
            {linkItems}
            {buttonItems}
        </div>
    </div>
}


export default TopNavigation